import { useState } from "react";
import { BiHide, BiShow } from "react-icons/bi";

function PasswordInput({ onChange, value, name }) {
  const [biShow, setBiShow] = useState(false);
  return (
    <>
      <h1 className="mb-1 mx-3">كلمة السر</h1>
      <div className="flex justify-between relative">
        <input
          type={!biShow ? "password" : "text"}
          onChange={onChange}
          value={value}
          name={name}
          autoComplete="new-password"
          placeholder="كلمة السر"
          className="w-full border-2 border-Main my-1 py-3 rounded-xl mx-2"
        />
        {biShow ? (
          <BiShow
            onClick={() => setBiShow(false)}
            size={25}
            className="absolute left-3 top-4 cursor-pointer"
          />
        ) : (
          <BiHide
            onClick={() => setBiShow(true)}
            size={25}
            className="absolute left-3 top-4 cursor-pointer"
          />
        )}
      </div>
    </>
  );
}
export default PasswordInput;
